import React from "react";
import { bool, string } from "prop-types";

import "./checkbox.css";

const Checkbox = ({ checked, label, disabled }) => (
  <div className={`cp-checkbox ${disabled ? 'is-disabled' : ''}`}>
    <label className={`${checked ? 'checked': ''}`}>{label}</label>
  </div>
);

Checkbox.propTypes = {
  checked: bool.isRequired,
  label: string.isRequired,
  disabled: bool,
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/views/components/generic/checkbox/Checkbox.jsx